(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(event) {
  	console.log('testIv10');
    $('.blog-slider').slick({
      dots: true,
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 10000
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-lookbook"]) return;
  try {
    
let lbContainer = document.getElementById("lookbookContent");
let sections = lbContainer.querySelectorAll('section');

sections.forEach((section) => {
    let title = section.firstElementChild;
    title.className = "Heading u-h2 SectionHeader--center";
	title.style['margin-bottom'] = '20px';

    let titleWrapper = document.createElement('div');
    titleWrapper.className = "Container";
    titleWrapper.appendChild(title);
    section.prepend(titleWrapper);


    let images = section.querySelectorAll('img');
    let grid = document.createElement('div');
    grid.className = "ProductList ProductList--grid  Grid";
    grid.setAttribute('data-mobile-count', '2');
    grid.setAttribute('data-desktop-count', '4');

    images.forEach((child) => {
        let gridCell = document.createElement('div');
        gridCell.className = "Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk";
        gridCell.appendChild(child);
        grid.appendChild(gridCell);
    });

    section.appendChild(grid);
});

  } catch(e) { console.error(e); }
})();
})();
